import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, ShieldCheck, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/hospital",           label: "Executive Dashboard", icon: LayoutDashboard, testid: "nav-hospital-dashboard" },
  { to: "/hospital/trust",     label: "Trust Index",         icon: ShieldCheck,     testid: "nav-hospital-trust" },
  { to: "/hospital/incidents", label: "Incidents",           icon: AlertTriangle,   testid: "nav-hospital-incidents" },
];

export default function HospitalCommandTabs() {
  const location = useLocation();
  return (
    <div className="mb-6 border-b border-border" data-testid="hospital-command-tabs">
      <nav className="flex items-center gap-1 overflow-x-auto">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = location.pathname === t.to;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={cn(
                "inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px",
                active
                  ? "text-primary border-primary"
                  : "text-muted-foreground border-transparent hover:text-primary hover:border-accent/40"
              )}
            >
              <Icon size={14} />
              {t.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
